import { TFunction } from 'next-i18next';

enum ContractStatusTranslation {
  'Draft' = 'draft',
  'For Activation' = 'forActivation',
  'Active' = 'active',
  'Terminated' = 'terminated',
  'Signed' = 'signed',
  'Rejected by ERP' = 'rejectedByErp',
  'Generated Contract' = 'generatedContract',
  'Rejected by Customer' = 'rejectedByCustomer',
  'Renewed' = 'renewed',
  'Canceled' = 'canceled',
  'Waiting for Validation' = 'waitingForValidation',
}

export const getStatusTranslation = ({ t, status }: { t: TFunction; status: string }) => {
  const translationKey = ContractStatusTranslation[status as keyof typeof ContractStatusTranslation];

  return t(`status.${translationKey}`);
};
